import { useLocation } from 'react-router-dom'
import { missionAt } from '@/content/missions'

/** Whether this is the home page: the site root or a mission's own address. */
export function useIsHome() {
  return Boolean(missionAt(useLocation().pathname))
}
